<template>
  <!-- Bucket Info Dialog -->
  <qc-dialog class="tc-15-rich-dialog cos" :show="innerShow" type="custom" :title="$t('cos.bucket_detail')" :width="520"
    :default-cancel="false" @close="closeDialog">
    <ul class="item-descr-list allow-user-select">
      <li>
        <span class="item-descr-tit">
          <label>{{$t("cos.bucket_name")}}</label>
        </span>
        <span class="item-descr-txt">
          <template v-if="filterInfo.Bucket">
            {{filterInfo.Bucket}}
            <a @click="copyText(filterInfo.Bucket)" href="javascript:void(0);" class="js-copy-access-link">
              <i class="copy-icon" :title="$t('core.copy')"></i>
            </a>
          </template>
          <template v-else>
            <qc-icon type="loading"></qc-icon>
          </template>
        </span>
      </li>
      <li v-if="$store.showRegion">
        <span class="item-descr-tit">{{$t("cos.region_name")}}</span>
        <span class="item-descr-txt">
          <template v-if="filterInfo.Region">{{filterInfo.Region || '-'}}</template>
          <qc-icon v-else type="loading"></qc-icon>
        </span>
      </li>
      <li>
        <span class="item-descr-tit">{{$t("cos.acl")}}</span>
        <template v-if="filterInfo.acl">
          <span class="item-descr-txt" :class="{'text-weak':['AccessDenied','Unknown'].includes(filterInfo.acl)}">
            {{filterInfo.aclText}}
            <a @click="onEditBucketAcl" href="javascript:void(0);" class="js-copy-access-link"
              v-show="0 && !['AccessDenied','Unknown'].includes(filterInfo.acl) && !$store.IsTegCos">
              <i class="pencil-icon" :title="$t('core.edit')"></i>
            </a>
          </span>
        </template>
        <qc-icon v-else type="loading"></qc-icon>
      </li>
      <li v-if="$store.IsQCloudCos">
        <span class="item-descr-tit">{{$t("cos.MAZ_configuration")}}</span>
        <span class="item-descr-txt" :class="{'text-weak':['AccessDenied','Unknown'].includes(filterInfo.MAZConfig)}">
          <template v-if="filterInfo.MAZConfig">{{filterInfo.MAZConfig | MAZState}}</template>
          <qc-icon v-else type="loading"></qc-icon>
        </span>
      </li>
      <li v-show="bucketInfo.versioning">
        <span class="item-descr-tit">{{$t("cos.version_control")}}</span>
        <template v-if="filterInfo.versioning">
          <span class="item-descr-txt">
            {{filterInfo.versioningText}}
            <a @click="onEditBucketVersioning" href="javascript:void(0);" class="js-copy-access-link"
              v-show="0 && !['accessdenied','unknown'].includes(filterInfo.versioning.toLowerCase())">
              <i class="pencil-icon" :title="$t('core.edit')"></i>
            </a>
          </span>
        </template>
        <qc-icon v-else type="loading"></qc-icon>
      </li>
      <li v-show="bucketInfo.imageSlim">
        <span class="item-descr-tit">
          {{$t('cos.image_slim')}}
          <qc-bubble type="dark" :append-to-body="false">
            <qc-icon type="plaint"></qc-icon>
            <template slot="popup">
              <div v-html="$t('cos.image_slim_tips_html')"></div>
            </template>
          </qc-bubble>
        </span>
        <span v-if="filterInfo.imageSlim" class="item-descr-txt" :class="{'text-weak':filterInfo.OFSConfig!=='OFS'
        && ['AccessDenied','Unknown','RegionUnsupport','UpsAppNotExist'].includes(filterInfo.imageSlim)}">
          <span v-if="typeof filterInfo.imageSlim === 'object'">
            <span v-if="filterInfo.imageSlim.SlimMode">
              <span v-if="slimModeArr.includes('Auto')">{{
                  $t('cos.image_slim_auto_opened', {suffixList: filterInfo.imageSlim && filterInfo.imageSlim.Suffixs
                        && filterInfo.imageSlim.Suffixs.Suffix|| []})
                }}</span>
              <br v-if="slimModeArr.includes('Auto') && slimModeArr.includes('API')"/>
              <span v-if="slimModeArr.includes('API')">{{$t('cos.image_slim_api_opened')}}</span>
            </span>
            <span v-else>
              {{$t('core.unopened')}}
            </span>
            <a @click="onEditBucketImageSlim" href="javascript:void(0);" class="js-copy-access-link">
              <i class="pencil-icon" :title="$t('core.edit')"></i>
            </a>
          </span>
          <span v-else class="text-weak">
            {{$t('core.unopened')}}
            <span v-if="filterInfo.OFSConfig==='OFS'">({{$t('error.ofs_image_slim_unsupport')}})</span>
            <span v-else-if="filterInfo.imageSlim==='AccessDenied'">({{$t('error.get_access_denied')}})</span>
            <span v-else-if="filterInfo.imageSlim==='RegionUnsupport'">
              ({{$t('error.region_image_slim_unsupport')}})
            </span>
            <span v-else-if="filterInfo.imageSlim==='UpsAppNotExist'">
              (<span v-html="$t('error.ups_app_not_exist_html')"></span>)
            </span>
          </span>
        </span>
        <qc-icon v-else type="loading"></qc-icon>
      </li>
      <li v-if="0">
        <span class="item-descr-tit">{{$t("cos.global_acceleration")}}</span>
        <template v-if="filterInfo.acceleration">
          <span class="item-descr-txt">
            {{filterInfo.accelerateConfigText}}
            <a @click="onEditBucketAccelerate" href="javascript:void(0);" class="js-copy-access-link"
              v-show="!['AccessDenied','Unknown'].includes(filterInfo.acceleration)">
              <i class="pencil-icon" :title="$t('core.edit')"></i>
            </a>
          </span>
        </template>
        <qc-icon v-else type="loading"></qc-icon>
      </li>
      <li>
        <span class="item-descr-tit">{{$t("cos.bucket_domain")}}</span>
        <span class="item-descr-txt">
          <template v-if="filterInfo.domain">
            {{filterInfo.domain}}
            <a @click="copyText(filterInfo.domain)" href="javascript:void(0);" class="js-copy-access-link">
              <i class="copy-icon" :title="$t('core.copy')"></i>
            </a>
          </template>
          <qc-icon v-else type="loading"></qc-icon>
        </span>
      </li>
    </ul>

    <div slot="button">
      <div class="justify-grid">
        <div class="col"></div>
        <div class="col">
          <qc-button type="weak" @click="closeDialog" :title="$t('core.close')">{{$t('core.close')}}
          </qc-button>
        </div>
      </div>
    </div>

  </qc-dialog>
</template>

<script>
import { getInnerProps, copyText2Clipboard } from '@/scripts/tools/utils';
import cos from '@/scripts/helper/cos';
// import cloudApi from '@@/scripts/helper/cloudapi';

export default {
  props: {
    show: {
      type: Boolean,
      required: true,
      default: false,
    },
    bucketInfo: {
      type: Object,
      required: true,
    },
  },
  computed: {
    innerShow: getInnerProps('show'),
    filterInfo() {
      const {
        Bucket, Region, versioning, acl, acceleration,
      } = this.bucketInfo;
      const aclText = window.lang.t(`cos.acl_map.${acl || 'private'}`);
      const bucketUrl = cos.getDefaultBucketDomain({ Bucket, Region });
      const versioningText = window.lang.t(
        `cos.version_map.${(versioning || 'disabled').toLowerCase()}`,
      );
      const accelerateConfigText = window.lang.t(
        `cos.global_acceleration_status.${acceleration || 'AccessDenied'}`,
      );

      return {
        ...this.bucketInfo,
        aclText,
        versioningText,
        domain: bucketUrl,
        Region,
        accelerateConfigText,
      };
    },
    slimModeArr() {
      return (this.filterInfo.imageSlim && this.filterInfo.imageSlim.SlimMode.split(',')) || [];
    },
  },
  methods: {
    // 复制文本到粘贴板
    copyText(text) {
      copyText2Clipboard(text);
    },
    // 编辑智能分层
    onEditBucketImageSlim() {
      this.$emit('edit', { type: 'imageSlim', item: this.bucketInfo });
      this.closeDialog();
    },
    // 编辑多版本
    onEditBucketVersioning() {
      this.$emit('edit', { type: 'versioning', item: this.bucketInfo });
      this.closeDialog();
    },
    onEditBucketAcl() {
      // const { Bucket, Region } = this.bucketInfo;
      // const params = {
      //   Bucket,
      //   Region,
      // };
      // this.checkCdnHost(params, allowEdit => {
      //   if (allowEdit) {
      //     this.$emit('edit', { type: 'acl', item: this.bucketInfo });
      //     this.closeDialog();
      //   }
      // });
    },
    // 编辑全球加速
    onEditBucketAccelerate() {
      this.$emit('edit', { type: 'acceleration', item: this.bucketInfo });
      this.closeDialog();
    },
    // checkCdnHost(params, cb) {
    //   // 编辑存储桶ACL前检查该存储桶是否绑定了 cdn 域名
    //   if (this.$store.IsQCloudCos && this.$store.CheckCdnBeforeDeleteBucket) {
    //     cloudApi.isCdnHostExistNew(params, (err, data) => {
    //       if (err) {
    //         const errorCode = err.code || err.Code;
    //         if (errorCode === 'CDN_HOST_EXIST') {
    //           tips.error(
    //             window.lang.t('error.edit_acl_failed_of_cdn_host_exist', err),
    //           );
    //           cb(false);
    //         } else if (errorCode === 'ResourceNotFound.CdnUserNotExists') {
    //           // 用户未开通 CDN 服务，则允许编辑存储桶ACL
    //           cb(true);
    //         } else {
    //           tips.error(window.lang.err(`error['${errorCode}']`, err));
    //           cb(false);
    //         }
    //       }
    //       if (data && data.code === 0) {
    //         cb(true);
    //       }
    //     });
    //   } else {
    //     cb(true);
    //   }
    // },
    closeDialog() {
      this.innerShow = false;
    },
  },
};
</script>

<style>
</style>
